import * as React from "react";
import PropTypes from "prop-types";
const SvgAchievementsKomHighlightedSmall = React.forwardRef(
  ({ color = "currentColor", size = 24, title, titleId, ...props }, ref) => (
    <svg
      fill={color}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      ref={ref}
      width={size}
      height={size}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <g fill="">
        <path d="M13.414.999a2 2 0 00-2.828 0L5.08 6.504 2.194 5.093C1.03 4.523-.26 5.6.092 6.848L2.678 16h18.644l2.586-9.152c.353-1.248-.937-2.325-2.102-1.755l-2.887 1.41zm-4.31 8.647l2.542-2.543a.5.5 0 01.708 0l2.542 2.543a.5.5 0 010 .707l-2.542 2.543a.5.5 0 01-.708 0l-2.542-2.543a.5.5 0 010-.707zM21 18H3v1a3 3 0 003 3h12a3 3 0 003-3z" />
      </g>
    </svg>
  )
);
SvgAchievementsKomHighlightedSmall.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  title: PropTypes.string,
  titleId: PropTypes.string,
};
export default SvgAchievementsKomHighlightedSmall;
